import { useEffect, useState } from "react";
import { getConfig } from "@/lib/api";

export function useGoFundMe() {
  const [url, setUrl] = useState("");
  useEffect(() => {
    getConfig()
      .then((c) => setUrl(c.gofundme_url || ""))
      .catch(() => {});
  }, []);
  return url;
}
